import React from 'react';

import BaseStatusDropdownButton from 'notebook/worksheets/components/BaseStatusDropdownButton';
import {WorksheetTaskStatusType} from 'notebook/worksheets/WorksheetConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Option from 'ui-library/menus/Option';

export const WORKSHEET_STEP_DROPDOWN_OPTIONS: Array<
  WorksheetTaskStatusType.SKIPPED | WorksheetTaskStatusType.FAILED
> = [WorksheetTaskStatusType.SKIPPED, WorksheetTaskStatusType.FAILED];

export const WORKSHEET_STEP_DROPDOWN_OPTIONS_DISPLAY_TEXT: Record<
  WorksheetTaskStatusType.SKIPPED | WorksheetTaskStatusType.FAILED,
  string
> = {
  [WorksheetTaskStatusType.SKIPPED]: 'Skip step',
  [WorksheetTaskStatusType.FAILED]: 'Fail step',
};

interface WorksheetStepDropdownButtonProps {
  locked: boolean;
  onSelect: (submitOption: WorksheetTaskStatusType) => void;
  className?: string;
}

/**
 * Dropdown menu for selecting an alternative submission option
 * for a step (e.g. SKIPPED or FAILED instead of COMPLETED/READY).
 *
 * This component is part of the larger {@link WorksheetStepStatusBadge}
 * parent component.
 */
export default function WorksheetStepDropdownButton({
  locked,
  onSelect,
  className,
}: WorksheetStepDropdownButtonProps): JSX.Element {
  const menuOptions = WORKSHEET_STEP_DROPDOWN_OPTIONS.map((option) => (
    <Option
      key={option}
      value={option}
      onSelect={() => {
        onSelect(option);
      }}
      {...getTestProps({component: 'WorksheetStepDropdownButton', element: 'option'})}
    >
      {WORKSHEET_STEP_DROPDOWN_OPTIONS_DISPLAY_TEXT[option]}
    </Option>
  ));

  return (
    <BaseStatusDropdownButton
      className={className}
      buttonStyle={ButtonStyle.PRIMARY}
      menuOptions={menuOptions}
      disabled={locked}
    />
  );
}
